import React, { Component } from "react";
import './header.css';
import { NavLink } from 'react-router-dom';

interface menuTemplate {

    phoneMenuState: string;
    screenShader: string;

}

export default class Header extends Component<any, menuTemplate> {

    constructor(props: any) {

        super(props)
        this.state = {phoneMenuState: "phoneMenuHidden", screenShader: "screenShaderHidden"}
    }

    openMenu = () => {

        if (this.state.phoneMenuState == "phoneMenuHidden") {

            this.setState({

                phoneMenuState: "phoneMenu",
                screenShader: "screenShader"

            });

        }

    }

    closeMenu = () => {

        this.setState({

            phoneMenuState: "phoneMenuHidden",
            screenShader: "screenShaderHidden"

        });

    }

    home = () => {

        this.closeMenu();

    }

    javascript = () => {

        this.closeMenu();

    }
    
    public render() {

        return(
            <div id = "header">
                
                <div id = "title">

                    <h1>Coders Unite!</h1>

                </div>

                <div id = "options">
                    <ul>
                        <li className = "regularMenuButton">
                            <NavLink to="/" exact><input type="button" id="button" value="Home"></input></NavLink>
                        </li>
                        <li className = "regularMenuButton">
                            <NavLink to="/javascript" exact><input type="button" id="button" value="Javascript"></input></NavLink>
                        </li>
                        <li className = "regularMenuButton"> 
                            <NavLink to="/python" exact><input type="button" id="button" value="Python"></input></NavLink>
                        </li>
                        <li className = "regularMenuButton">
                            <NavLink to="/java" exact><input type="button" id="button" value="Java"></input></NavLink>
                        </li>
                        <li className = "regularMenuButton">
                            <NavLink to="/php" exact><input type="button" id="button" value="PHP"></input></NavLink>
                        </li>
                        <li className = "regularMenuButton">
                            <NavLink to="/c" exact><input type="button" id="button" value="C"></input></NavLink>
                        </li>
                        <li className = "smallMenuButton">

                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" fill="currentColor" className="bi bi-list" viewBox="0 0 16 16"  onClick = {this.openMenu}>
                                <path fillRule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z" />
                            </svg>

                        </li>

                    </ul>

                </div>

                <div id = {this.state.screenShader} onClick = {this.closeMenu}>


                </div>

                <div id = {this.state.phoneMenuState}>

                    <NavLink to="/" exact><input type="button" id="phoneButton" value="Home" onClick = {this.home}></input></NavLink>
                    <NavLink to="/javascript" exact><input type="button" id="phoneButton" value="Javascript" onClick = {this.javascript}></input></NavLink>
                    <NavLink to="/python" exact><input type="button" id="phoneButton" value="Python"></input></NavLink>
                    <NavLink to="/java" exact><input type="button" id="phoneButton" value="Java"></input></NavLink>
                    <NavLink to="/php" exact><input type="button" id="phoneButton" value="PHP"></input></NavLink>
                    <NavLink to="/c" exact><input type="button" id="phoneButton" value="C"></input></NavLink>

                </div>

            </div>
        );
    }
}